import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomPreloadingStrategy } from './custom-preloading';
import { PublicGuardService } from 'app/private/_core/_services/public-guard.service';
import { PrivateGuardService } from 'app/private/_core/_services/private-guard.service';
import { PreloadType } from 'app/shared/_models/preload-type.model';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'error/404',
		pathMatch: 'full'
	},
	{
		path: 'error/:code',
		loadChildren: () => import('./error/error.module').then(m => m.ErrorModule),
		data: { preload: PreloadType.Always },
	},
	{
		path: 'password-reset/:ref',
		loadChildren: () =>
			import('app/private/password-reset/password-reset.module').then(
				m => m.PasswordResetModule
			),
		canActivate: [PrivateGuardService],
		data: { preload: PreloadType.Private },
	},
	{
		path: 'public',
		loadChildren: () => import('./public/public.module').then(m => m.PublicModule),
		canActivate: [PublicGuardService],
		data: { preload: PreloadType.Public },
	},
	{
		path: 'teams/password-reset/:ref',
		loadChildren: () =>
			import('app/private/password-reset/password-reset.module').then(
				m => m.PasswordResetModule
			),
		canActivate: [PrivateGuardService],
		data: { preload: PreloadType.Private },
	},
	{
		path: 'teams/accept-invite/:ref',
		loadChildren: () =>
			import('app/private/teams-invite-accept/teams-invite-accept.module').then(
				m => m.TeamsInviteAcceptModule
			),
		canActivate: [PrivateGuardService],
		data: { preload: PreloadType.Private },
	},
	{
		path: ':param',
		loadChildren: () => import('./private/private.module').then(m => m.PrivateModule),
		canActivate: [PrivateGuardService],
		data: { preload: PreloadType.Private },
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			preloadingStrategy: CustomPreloadingStrategy,
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}
